import 'jstree';

import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import * as _ from 'lodash';
import { forkJoin, from, of } from 'rxjs';
import { concatMap, map, toArray } from 'rxjs/operators';
import { pureRulesDetailsModel } from 'src/app/common/models/PureRuleDetailsModel';
import { recipeModel } from 'src/app/common/models/recipeDetailsModel';
import { EXECUTE_RULE_TABLE_COLUMNS, EXECUTE_RULE_TABLE_COLUMNS_EXCEL, PROPERTY_BASED_RULE_TYPE_IDS } from 'src/app/common/models/tableColumns';
import { DataService } from 'src/app/common/services/data.service';
import { environment } from 'src/environments/environment';
import { ColumnBindingService } from 'src/app/common/services/column-binding.service';

import { AssessRequestRaService } from '../assess-request-ra.service';

@Component({
  selector: 'app-execute-rules-ra',
  templateUrl: './execute-rules-ra.component.html',
  styleUrls: ['./execute-rules-ra.component.scss']
})
export class ExecuteRulesRaComponent implements OnInit {

  prepareRuleColumns = [];
  prepareRuleColumnsExcel = [];
  rpcdata = [];
  rpcUnileverMarket = [];
  rpcOtherMarket = [];
  overlayText = '';
  hideOverlay = true;
  prepareRulePageTableView = true;
  prepareRuleTabView = false;
  prepareRuleTableData = [];
  TFCName;
  selectedMarket;
  unileverMarketObj = {
    marketId: ''
  };
  marketsToSelect = [];
  loading = true;
  rulesLoading = false;
  private rulesLoadStarted = false;
  rpc;
  unileverRpc = [];
  sIRIds: any;
  sirIdList = [];
  isPlm: true;
  tfc: any;
  execRulePageLoadingMessage;
  sirIDInvalidList = [];
  goToWorklistConfirmation = false;
  rpcdataForTree = [];
  rpcToSelect = [];
  tfcData = [];
  selectedRPC = '';
  rpcFullData = [];
  rpcData = [];
  market = '';
  businessGroup = '';
  prepareRuleBtnDissageFlag = true;
  warningTextOpen: boolean;
  tablewarningComment: any;
  orrTextOpen: boolean;
  tableORRComment: any;
  isColumnsHasHyperLinks = 'Yes';
  roleName = '';
  informationTextOpen: boolean;
  tableInformationComment: any;
  constructor(
    public assessraService: AssessRequestRaService,
    public matSnackBar: MatSnackBar,
    private dataService: DataService,
    private columnBindingService: ColumnBindingService,
    private route: Router
  ) { }

  /* istanbul ignore next */
  ngOnInit() {
    const roleData = localStorage.getItem('roles');
    const data = roleData.split(',');
    let listRole = [];
    for (const val of data) {
      if (val.toLowerCase().startsWith('fast')) {
        listRole.push(val);
      }
    }
    listRole = _.uniqBy(listRole);
    this.roleName = listRole.join(',');
    this.prepareRuleColumns = EXECUTE_RULE_TABLE_COLUMNS;
    this.prepareRuleColumnsExcel = EXECUTE_RULE_TABLE_COLUMNS_EXCEL;

    this.selectedMarket = recipeModel.marketDetails.marketName;
    this.isPlm = recipeModel.isPLMRequest;
    this.market = this.selectedMarket;
    this.businessGroup = (recipeModel as any).businessGroupName;
    this.isColumnsHasHyperLinks = 'Yes';
    pureRulesDetailsModel.selectedMarketForRulesDisplay = recipeModel.marketDetails;
    this.tfc = recipeModel.tfc;
    this.getFallbackMarkets();
    this.dataService.setSelectedStep(2);
    this.getTFCbyID();
  }

  /* istanbul ignore next */
  getFallbackMarkets() {
    const marketName = recipeModel.marketDetails.marketName;
    this.loading = true;
    const serviceCall = this.assessraService.getFallBackMktData(marketName);
    if (serviceCall !== undefined) {
      serviceCall.subscribe((data: any[]) => {
        this.marketsToSelect = _.uniqBy([...(data || []), recipeModel.marketDetails], value => String(value.marketId));
        this.unileverMarketObj = this.marketsToSelect.filter(x => x.marketName === 'Unilever')[0];
        this.initializeRulesView();
      }, (error) => {
        this.loading = false;
      });
    }
  }

  private initializeRulesView() {
    // Both requests must finish before loading MRPCs or issuing the initial rule requests.
    if (!this.TFCName || this.marketsToSelect.length === 0 || this.rulesLoadStarted) {
      return;
    }
    this.selectedMarket = this.marketsToSelect.find(value => String(value.marketId) === String(recipeModel.marketDetails.marketId));
    this.getRPCDataBasedOnMarket(this.market);
    this.getPrepareRuleTableData();
  }

  onMarketChange(filterVal: any) {
    this.rpcToSelect = [];
    this.market = filterVal.value.marketName;
    pureRulesDetailsModel.selectedMarketForRulesDisplay = this.marketsToSelect.filter(x => x.marketName === filterVal.value.marketName)[0];
    $('#treeDiv').jstree('destroy').empty();
    $('#treeDivUni').jstree('destroy').empty();
    this.getRPCDataBasedOnMarket(pureRulesDetailsModel.selectedMarketForRulesDisplay.marketName);
    setTimeout(() => {
      this.loading = true;
      this.getRPCbyMarketAndTfc(pureRulesDetailsModel.selectedMarketForRulesDisplay, 1);
    }, 1000);
  }
  /* istanbul ignore next */
  get isRequestAssessment(): boolean {
    const clicked = this.dataService.getAssessmentClicked();
    if (clicked === 'Self Assessment') {
      return false;
    }
    const status = recipeModel.requestStatus;
    return status === 'Submitted' || status === 'Assigned' || status === 'In Progress – RA' || status === 'In Progress' || !clicked;
  }

  getSelectedAssessmentRpcs(): any[] {
    if (!this.isRequestAssessment) {
      return [];
    }
    if (this.rpcOtherMarket && Array.isArray(this.rpcOtherMarket)) {
      const checked = this.rpcOtherMarket.filter(n => n.isChecked === true || n.isChecked === 'true' || n.isChecked === 'checked');
      if (checked.length > 0) {
        return checked.map(n => ({
          rpcId: String(n.id),
          rpcName: n.text,
          rpcFullText: n.fullText || n.rpcFullText
        }));
      }
    }
    if (this.rpcUnileverMarket && Array.isArray(this.rpcUnileverMarket)) {
      const checked = this.rpcUnileverMarket.filter(n => n.isChecked === true || n.isChecked === 'true' || n.isChecked === 'checked');
      if (checked.length > 0) {
        return checked.map(n => ({
          rpcId: String(n.id),
          rpcName: n.text,
          rpcFullText: n.fullText || n.rpcFullText
        }));
      }
    }
    if (recipeModel && recipeModel.userSelectedMarketRPCList && recipeModel.userSelectedMarketRPCList.length > 0) {
      return recipeModel.userSelectedMarketRPCList;
    }
    if (recipeModel && recipeModel.selectedAssessmentRpcs && recipeModel.selectedAssessmentRpcs.length > 0) {
      return recipeModel.selectedAssessmentRpcs;
    }
    return [];
  }

  applySelectiveRpcFilter(treeData: any[]): any[] {
    if (!treeData || !Array.isArray(treeData) || treeData.length === 0) {
      return treeData;
    }
    if (!this.isRequestAssessment) {
      return treeData;
    }

    const checkedNodes = treeData.filter(node =>
      node.isChecked === true || node.isChecked === 'true' || node.isChecked === 'checked'
    );

    // If isChecked is false for every rpc node, then it should work as per current behaviour
    if (checkedNodes.length === 0) {
      return treeData;
    }

    // Union of all hierarchy paths from checked leaf nodes up to root
    const allowedNodeIds = new Set<string>();
    checkedNodes.forEach(leaf => {
      allowedNodeIds.add(String(leaf.id));
      let currParent = String(leaf.parent);
      while (currParent && currParent !== '#' && currParent !== '0' && currParent !== 'null' && currParent !== 'undefined') {
        allowedNodeIds.add(currParent);
        const parentNode = treeData.find(n => String(n.id) === currParent);
        if (!parentNode) {
          break;
        }
        currParent = String(parentNode.parent);
      }
    });

    // Enable allowed nodes, grey out all other nodes
    treeData.forEach(node => {
      const isAllowed = allowedNodeIds.has(String(node.id));
      if (!isAllowed) {
        node.state = {
          ...(node.state || {}),
          disabled: true,
          selected: false
        };
        const existingClass = (node.a_attr && node.a_attr.class) ? node.a_attr.class : '';
        node.a_attr = {
          ...(node.a_attr || {}),
          class: (existingClass.replace(/jstree-disabled|jstree-readonly/g, '') + ' jstree-disabled jstree-readonly').trim()
        };
      } else {
        if (node.state) {
          node.state.disabled = false;
        }
        if (node.a_attr && node.a_attr.class) {
          node.a_attr.class = node.a_attr.class.replace(/jstree-disabled|jstree-readonly/g, '').trim();
        }
      }
    });

    return treeData;
  }

  isTopLevelRpc(name?: string, fullText?: string, pId?: any): boolean {
    const pIdStr = pId !== undefined && pId !== null ? String(pId).trim() : '';
    if (pIdStr === '#' || pIdStr === '0') {
      return true;
    }
    const cleanFull = (fullText || '').trim();
    if (!cleanFull) {
      return false;
    }
    if (!cleanFull.includes('_')) {
      return true;
    }
    const topCategory = cleanFull.split('_')[0].trim().toLowerCase();
    if (name && name.trim().toLowerCase() === topCategory) {
      return true;
    }
    return false;
  }

  isAncestorRpc(parent: any, child: any, treeNodes?: any[]): boolean {
    if (!parent || !child) {
      return false;
    }
    const pId = String(parent.rpcId !== undefined ? parent.rpcId : parent.id).trim();
    const cId = String(child.rpcId !== undefined ? child.rpcId : child.id).trim();
    if (pId && cId && pId === cId) {
      return false;
    }

    if (child.parentRpcId && String(child.parentRpcId).trim() === pId) {
      return true;
    }
    if (child.parentId && String(child.parentId).trim() === pId) {
      return true;
    }

    if (Array.isArray(treeNodes) && treeNodes.length > 0) {
      const cNode = treeNodes.find(n => String(n.id).trim() === cId);
      if (cNode) {
        if (Array.isArray(cNode.parents) && cNode.parents.some((p: any) => String(p).trim() === pId)) {
          return true;
        }
        if (cNode.parent && String(cNode.parent).trim() === pId) {
          return true;
        }
      }
    }

    const pFull = (parent.rpcFullText || '').trim().toLowerCase();
    const cFull = (child.rpcFullText || '').trim().toLowerCase();
    if (pFull && cFull && cFull.startsWith(pFull + '_')) {
      return true;
    }

    const pName = (parent.rpcName || '').trim().toLowerCase();
    const cName = (child.rpcName || '').trim().toLowerCase();
    if (pName && cFull && pName !== cName) {
      if (cFull.includes('_' + pName + '_') || cFull.startsWith(pName + '_') || cFull.endsWith('_' + pName)) {
        return true;
      }
    }

    return false;
  }

  sortRpcsHierarchically(list: any[], treeNodes?: any[]): any[] {
    if (!Array.isArray(list) || list.length <= 1) {
      return list || [];
    }
    const nodes = treeNodes || [
      ...(Array.isArray(this.rpcOtherMarket) ? this.rpcOtherMarket : []),
      ...(Array.isArray(this.rpcUnileverMarket) ? this.rpcUnileverMarket : [])
    ];
    return list.slice().sort((x: any, y: any) => {
      if (this.isAncestorRpc(x, y, nodes)) {
        return -1;
      }
      if (this.isAncestorRpc(y, x, nodes)) {
        return 1;
      }

      const xFull = (x.rpcFullText || '').toLowerCase();
      const yFull = (y.rpcFullText || '').toLowerCase();
      const xParts = xFull.split('_');
      const yParts = yFull.split('_');

      const xBranch = xParts.slice(0, 2).join('_');
      const yBranch = yParts.slice(0, 2).join('_');
      if (xBranch !== yBranch) {
        return xBranch.localeCompare(yBranch);
      }

      if (xParts.length !== yParts.length) {
        return xParts.length - yParts.length;
      }

      return xFull.localeCompare(yFull);
    });
  }

  filterMarketRpcList(marketRpcList: any[], allowedRpcs: any[], isSelectionActive: boolean, defaultMarkets?: any[]): any[] {
    if (!isSelectionActive || !Array.isArray(allowedRpcs) || allowedRpcs.length === 0) {
      return marketRpcList;
    }

    const allowedRpcIdSet = new Set(allowedRpcs.map(r => String(r.rpcId !== undefined ? r.rpcId : r.id).trim()));

    if (Array.isArray(marketRpcList) && marketRpcList.length > 0) {
      const kept = marketRpcList.filter(item => {
        if (item && (item.marketName === 'Unilever' || String(item.marketId) === '283')) {
          return false;
        }
        const idStr = String(item.rpcId !== undefined ? item.rpcId : item.id).trim();
        return allowedRpcIdSet.has(idStr);
      });

      const nonUnileverMarkets = marketRpcList.filter(
        m => m && m.marketName !== 'Unilever' && String(m.marketId) !== '283'
      );
      const uniqueMarkets: any[] = _.uniqBy(
        (nonUnileverMarkets.length > 0 ? nonUnileverMarkets : marketRpcList).map(m => ({
          marketId: m.marketId,
          marketName: m.marketName,
          level: m.level,
          isCluster: m.isCluster,
          isCountry: m.isCountry,
          isState: m.isState
        })),
        'marketId'
      ).filter(m => m && m.marketName !== 'Unilever' && String(m.marketId) !== '283');

      allowedRpcs.forEach(rpc => {
        const rpcIdStr = String(rpc.rpcId !== undefined ? rpc.rpcId : rpc.id).trim();
        uniqueMarkets.forEach(m => {
          const exists = kept.some(k =>
            String(k.marketId) === String(m.marketId) &&
            String(k.rpcId !== undefined ? k.rpcId : k.id).trim() === rpcIdStr
          );
          if (!exists) {
            kept.push({
              marketId: m.marketId,
              marketName: m.marketName,
              rpcId: rpc.rpcId !== undefined ? String(rpc.rpcId) : String(rpc.id),
              rpcName: rpc.rpcName || rpc.rpcDescription || rpc.text,
              rpcFullText: rpc.rpcFullText || rpc.fullHierarchyText || rpc.FullText || rpc.rpcSearchValue,
              messageText: null,
              mrpcid: rpc.mrpcid || rpc.mrpcId || 0,
              level: m.level !== undefined ? m.level : 0,
              isCluster: m.isCluster !== undefined ? m.isCluster : false,
              isCountry: m.isCountry !== undefined ? m.isCountry : null,
              isState: m.isState !== undefined ? m.isState : null,
              isChecked: null
            });
          }
        });
      });

      const sortedResult: any[] = [];
      allowedRpcs.forEach(rpc => {
        const rpcIdStr = String(rpc.rpcId !== undefined ? rpc.rpcId : rpc.id).trim();
        uniqueMarkets.forEach(m => {
          const match = kept.find(k =>
            String(k.marketId) === String(m.marketId) &&
            String(k.rpcId !== undefined ? k.rpcId : k.id).trim() === rpcIdStr
          );
          if (match) {
            sortedResult.push(match);
          }
        });
      });
      return sortedResult.length > 0 ? sortedResult : kept;
    }

    if (Array.isArray(defaultMarkets) && defaultMarkets.length > 0) {
      const result: any[] = [];
      allowedRpcs.forEach(rpc => {
        defaultMarkets.forEach(m => {
          result.push({
            marketId: m.marketId,
            marketName: m.marketName,
            rpcId: rpc.rpcId !== undefined ? String(rpc.rpcId) : String(rpc.id),
            rpcName: rpc.rpcName || rpc.rpcDescription || rpc.text,
            rpcFullText: rpc.rpcFullText || rpc.fullHierarchyText || rpc.FullText || rpc.rpcSearchValue,
            messageText: null,
            mrpcid: rpc.mrpcid || rpc.mrpcId || 0,
            level: m.level !== undefined ? m.level : 0,
            isCluster: m.isCluster !== undefined ? m.isCluster : false,
            isCountry: m.isCountry !== undefined ? m.isCountry : null,
            isState: m.isState !== undefined ? m.isState : null,
            isChecked: null
          });
        });
      });
      return result;
    }

    return marketRpcList;
  }

  updateRecipeModelRpcs(selectedMarket: any): void {
    recipeModel.rpcList = this.rpc;

    const selectedAssessmentRpcs = this.getSelectedAssessmentRpcs();
    const isSelectiveActive = this.isRequestAssessment && selectedAssessmentRpcs && selectedAssessmentRpcs.length > 0;
    const defaultMarkets = [selectedMarket].filter(m => m && m.marketId && m.marketName !== 'Unilever' && String(m.marketId) !== '283');
    const leavesOnly = isSelectiveActive ? selectedAssessmentRpcs : this.rpc;
    const updatedMrpcList = this.filterMarketRpcList(recipeModel.marketRPCList, leavesOnly, isSelectiveActive, defaultMarkets);

    if (Array.isArray(updatedMrpcList)) {
      recipeModel.marketRPCList = updatedMrpcList.filter((m: any) => m && m.marketName !== 'Unilever' && String(m.marketId) !== '283');
    } else {
      recipeModel.marketRPCList = updatedMrpcList;
    }
  }

  extractAndFilterRpcs(rawRpcList: any[]): any[] {
    if (!rawRpcList || !Array.isArray(rawRpcList) || rawRpcList.length === 0) {
      return [];
    }

    const selectedAssessmentRpcs = this.getSelectedAssessmentRpcs();
    if (!this.isRequestAssessment || !selectedAssessmentRpcs || selectedAssessmentRpcs.length === 0) {
      return rawRpcList.map(respElem => ({
        rpcId: respElem.rpcId,
        rpcName: respElem.rpcDescription || respElem.rpcName,
        rpcFullText: respElem.rpcSearchValue || respElem.rpcFullText
      }));
    }

    const allRpcItems: any[] = [];
    const collectRpcs = (list: any[], parentItem?: any) => {
      if (!list || !Array.isArray(list)) {
        return;
      }
      list.forEach(item => {
        let parentRpcId = item.parentRpcId !== undefined ? item.parentRpcId : (item.parentId !== undefined ? item.parentId : undefined);
        if ((parentRpcId === undefined || parentRpcId === 0 || parentRpcId === '0') && parentItem) {
          parentRpcId = parentItem.rpcId !== undefined ? parentItem.rpcId : parentItem.id;
        }
        const parentRpcName = item.parentRpcDescription || item.parentRpcName ||
          (parentItem ? (parentItem.rpcDescription || parentItem.rpcName || parentItem.text) : '');
        const parentRpcFullText = item.parentRpcSearchValue || item.parentRpcFullText ||
          (parentItem ? (parentItem.rpcSearchValue || parentItem.rpcFullText || parentItem.fullText) : '');

        const rpcItem = {
          rpcId: item.rpcId !== undefined ? item.rpcId : item.id,
          rpcName: item.rpcDescription || item.rpcName || item.text,
          rpcFullText: item.rpcSearchValue || item.rpcFullText || item.fullHierarchyText || item.fullText,
          parentRpcId: parentRpcId,
          parentRpcName: parentRpcName,
          parentRpcFullText: parentRpcFullText,
          parentItem: parentItem,
          raw: item
        };
        allRpcItems.push(rpcItem);
        if (item.childRpcs && Array.isArray(item.childRpcs) && item.childRpcs.length > 0) {
          collectRpcs(item.childRpcs, rpcItem);
        }
      });
    };
    collectRpcs(rawRpcList);

    const matchedLeaves = allRpcItems.filter(item => {
      return selectedAssessmentRpcs.some(sel => {
        const selId = String(sel.rpcId !== undefined ? sel.rpcId : (sel.id !== undefined ? sel.id : '')).trim();
        const itemId = String(item.rpcId !== undefined ? item.rpcId : '').trim();
        if (selId && itemId && selId === itemId) {
          return true;
        }
        const selDesc = (sel.rpcDescription || sel.rpcName || sel.text || '').trim().toLowerCase();
        const itemDesc = (item.rpcName || '').trim().toLowerCase();
        if (selDesc && itemDesc && selDesc === itemDesc) {
          return true;
        }
        const selFull = (sel.fullHierarchyText || sel.rpcFullText || sel.FullText || '').trim().toLowerCase();
        const itemFull = (item.rpcFullText || '').trim().toLowerCase();
        if (selFull && itemFull && selFull === itemFull) {
          return true;
        }
        return false;
      });
    });

    const leavesToProcess = matchedLeaves.length > 0 ? matchedLeaves : selectedAssessmentRpcs.map(sel => ({
      rpcId: sel.rpcId !== undefined ? sel.rpcId : sel.id,
      rpcName: sel.rpcName || sel.rpcDescription || sel.text,
      rpcFullText: sel.rpcFullText || sel.fullHierarchyText || sel.FullText || sel.rpcSearchValue,
      parentRpcId: (sel.parent !== undefined && sel.parent !== '#' && sel.parent !== '0') ? sel.parent : undefined
    }));

    const treeNodes: any[] = [
      ...(Array.isArray(this.rpcOtherMarket) ? this.rpcOtherMarket : []),
      ...(Array.isArray(this.rpcUnileverMarket) ? this.rpcUnileverMarket : [])
    ];

    const allowedRpcIds = new Set<string>();
    const extraParentObjs: any[] = [];

    leavesToProcess.forEach(leaf => {
      allowedRpcIds.add(String(leaf.rpcId));

      // 1. Walk up parentItem in rawRpcList
      let curr = leaf;
      let depth = 0;
      while (curr && curr.parentItem && depth < 20) {
        depth++;
        const p = curr.parentItem;
        if (!this.isTopLevelRpc(p.rpcName, p.rpcFullText, p.parentRpcId)) {
          allowedRpcIds.add(String(p.rpcId));
          extraParentObjs.push(p);
        }
        curr = p;
      }

      // 2. Walk up jstree treeNodes if present
      if (treeNodes.length > 0) {
        const leafIdStr = String(leaf.rpcId).trim();
        const treeNode = treeNodes.find(n =>
          String(n.id).trim() === leafIdStr ||
          (n.text && leaf.rpcName && n.text.trim().toLowerCase() === leaf.rpcName.trim().toLowerCase())
        );

        if (treeNode) {
          if (Array.isArray(treeNode.parents) && treeNode.parents.length > 0) {
            treeNode.parents.forEach((pId: any) => {
              const pIdStr = String(pId).trim();
              if (pIdStr && pIdStr !== '#' && pIdStr !== '0' && pIdStr !== 'null') {
                const pTreeNode = treeNodes.find(n => String(n.id).trim() === pIdStr);
                if (pTreeNode) {
                  const isTop = (pTreeNode.parent === '#' || pTreeNode.parent === '0' || !pTreeNode.parent) ||
                    this.isTopLevelRpc(pTreeNode.text, pTreeNode.fullText || pTreeNode.rpcFullText, pTreeNode.parent);
                  if (!isTop) {
                    allowedRpcIds.add(pIdStr);
                    extraParentObjs.push({
                      rpcId: pTreeNode.id,
                      rpcName: pTreeNode.text,
                      rpcFullText: pTreeNode.fullText || pTreeNode.rpcFullText || pTreeNode.FullText || ''
                    });
                  }
                }
              }
            });
          } else {
            let currPId = treeNode.parent ? String(treeNode.parent).trim() : '';
            const visited = new Set<string>();
            while (currPId && currPId !== '#' && currPId !== '0' && currPId !== 'null' && !visited.has(currPId)) {
              visited.add(currPId);
              const pTreeNode = treeNodes.find(n => String(n.id).trim() === currPId);
              if (!pTreeNode) {
                break;
              }
              const isTop = (pTreeNode.parent === '#' || pTreeNode.parent === '0' || !pTreeNode.parent) ||
                this.isTopLevelRpc(pTreeNode.text, pTreeNode.fullText || pTreeNode.rpcFullText, pTreeNode.parent);
              if (!isTop) {
                allowedRpcIds.add(currPId);
                extraParentObjs.push({
                  rpcId: pTreeNode.id,
                  rpcName: pTreeNode.text,
                  rpcFullText: pTreeNode.fullText || pTreeNode.rpcFullText || pTreeNode.FullText || ''
                });
              } else {
                break;
              }
              currPId = pTreeNode.parent ? String(pTreeNode.parent).trim() : '';
            }
          }
        }
      }

      // 3. Fallback: Parse rpcFullText underscore path
      if (leaf.rpcFullText && leaf.rpcFullText.includes('_')) {
        const parts = leaf.rpcFullText.split('_').map((p: string) => p.trim()).filter((p: string) => p.length > 0);
        if (parts.length >= 2) {
          const intermediateNames = parts.slice(1, parts.length - 1).map((p: string) => p.toLowerCase());
          intermediateNames.forEach((pName: string) => {
            let found = allRpcItems.find(item =>
              item && item.rpcName && item.rpcName.trim().toLowerCase() === pName &&
              String(item.rpcId) !== String(leaf.rpcId)
            );
            if (!found && treeNodes.length > 0) {
              const tNode = treeNodes.find(n =>
                n && n.text && n.text.trim().toLowerCase() === pName &&
                String(n.id) !== String(leaf.rpcId)
              );
              if (tNode) {
                found = {
                  rpcId: tNode.id,
                  rpcName: tNode.text,
                  rpcFullText: tNode.fullText || tNode.rpcFullText || tNode.FullText || ''
                };
              }
            }
            if (found && !this.isTopLevelRpc(found.rpcName, found.rpcFullText, found.parentRpcId)) {
              allowedRpcIds.add(String(found.rpcId));
              extraParentObjs.push(found);
            }
          });
        }
      }
    });

    const result: any[] = [];
    allRpcItems.forEach(item => {
      const idStr = String(item.rpcId);
      if (allowedRpcIds.has(idStr)) {
        result.push({
          rpcId: item.rpcId,
          rpcName: item.rpcName,
          rpcFullText: item.rpcFullText
        });
        allowedRpcIds.delete(idStr);
      }
    });

    extraParentObjs.forEach(p => {
      const idStr = String(p.rpcId);
      if (allowedRpcIds.has(idStr)) {
        result.unshift({
          rpcId: p.rpcId,
          rpcName: p.rpcName,
          rpcFullText: p.rpcFullText
        });
        allowedRpcIds.delete(idStr);
      }
    });

    leavesToProcess.forEach(l => {
      const idStr = String(l.rpcId);
      if (allowedRpcIds.has(idStr)) {
        result.push({
          rpcId: l.rpcId,
          rpcName: l.rpcName,
          rpcFullText: l.rpcFullText
        });
        allowedRpcIds.delete(idStr);
      }
    });

    const uniqueResult = _.uniqBy(result, 'rpcId');
    const sortedResult = this.sortRpcsHierarchically(uniqueResult, treeNodes);
    return sortedResult.map(item => ({
      rpcId: item.rpcId,
      rpcName: item.rpcName,
      rpcFullText: item.rpcFullText
    }));
  }

  getRPCbyMarketAndTfc(selectedMarket, updateRpcList) {
    this.rpc = [];
    let index;
    this.tfc = recipeModel.tfc;
    this.loading = true;
    const encodedTfcName = encodeURIComponent(encodeURIComponent(encodeURIComponent(this.tfc.tfcId)));
    const apiurl = environment.APIFAsT + '/markets/' + selectedMarket.marketId + '/tfcs/' + encodedTfcName + '/rpcs';
    const url = environment.APIFAsT + '/markets/' + this.unileverMarketObj.marketId + '/tfcs/' + encodedTfcName + '/rpcs';
    const serviceCall = forkJoin([this.assessraService.getData(apiurl), this.assessraService.getData(url)]);
    if (serviceCall !== undefined) {
      serviceCall.subscribe((response) => {
        if (response[0] !== undefined && response[0].length !== 0) {
          this.rpc = this.extractAndFilterRpcs(response[0]);
          this.loading = false;
        }
        if (response[1] !== undefined && response[1].length !== 0) {
          this.unileverRpc = this.extractAndFilterRpcs(response[1]);
          this.loading = false;
        }
        if (response[0] !== undefined && (response[0].length === 0 || response[0].text === 'No Regulatory Product Class is Mapped')) {
          this.loading = false;
          this.matSnackBar.open('RPC Not mapped for Market ' + selectedMarket.marketName + ' and TFC ' + this.tfc.tfcName, 'close', {
            duration: 3900,
            panelClass: ['error']
          });
        }
        const selectedAssessmentRpcs = this.getSelectedAssessmentRpcs();
        if (this.isRequestAssessment && selectedAssessmentRpcs && selectedAssessmentRpcs.length > 0) {
          const fallbackSelected = selectedAssessmentRpcs.map(r => ({
            rpcId: r.rpcId !== undefined ? r.rpcId : r.id,
            rpcName: r.rpcName || r.rpcDescription || r.text,
            rpcFullText: r.rpcFullText || r.fullHierarchyText || r.rpcSearchValue
          }));
          if (this.rpc.length === 0) {
            this.rpc = fallbackSelected;
          }
          if (this.unileverRpc.length === 0) {
            this.unileverRpc = fallbackSelected;
          }
          if (this.unileverRpc.length !== 0) {
            this.unileverRpc.forEach((rpcValue) => {
              index = _.findIndex(this.rpc, (value) => String(value.rpcId) === String(rpcValue.rpcId));
              if (index === -1) {
                this.rpc.push(rpcValue);
              }
            });
          }
          this.rpc = this.sortRpcsHierarchically(this.rpc);
        } else {
          if (this.unileverRpc.length !== 0) {
            this.unileverRpc.forEach((rpcValue) => {
              index = _.findIndex(this.rpc, (value) => value.rpcId === rpcValue.rpcId);
              if (index === -1) {
                this.rpc.push(rpcValue);
              }
            });
          }
        }
        if (updateRpcList === 1) {
          this.updateRecipeModelRpcs(selectedMarket);
        }
        this.getPrepareRuleTableData();
      }, (error) => {
        this.loading = false;
      });
    }
  }
   /* istanbul ignore next */
  getRpcTree(market) {
    const encodedTfcName = encodeURIComponent(encodeURIComponent(encodeURIComponent(recipeModel.tfcFullText)));
    const otherMarketRpcTreeApiurl = environment.APIFAsT + '/markets/' + market + '/tfcname/' + encodedTfcName + '/rpcs/fortree';
    const unileverRpctreeApiurl = environment.APIFAsT + '/markets/Unilever/tfcname/' + encodedTfcName + '/rpcs/fortree';
    const serviceCall = forkJoin([this.assessraService.getData(otherMarketRpcTreeApiurl), this.assessraService.getData(unileverRpctreeApiurl)]);
    serviceCall.subscribe((response) => {
      if (response[0] !== null) {
        this.rpcOtherMarket = response[0];
        this.createRpcTree(this.rpcOtherMarket);
      }
      if (response[1] !== null) {
        this.rpcUnileverMarket = response[1];
        this.createRpcTreeUnilever(this.rpcUnileverMarket);
      }
    }, (error) => {
      this.loading = false;
    });
  }
  /* istanbul ignore next */
  createRpcTree(rpcdata) {
    rpcdata = this.applySelectiveRpcFilter(rpcdata);
    try {
      if ($.jstree.reference('#treeDiv')) {
        $('#treeDiv').jstree('destroy').empty();
      }
    } catch (e) {}
    $('#treeDiv').off('changed.jstree');
    $('#treeDiv').on('changed.jstree', (evt, data) => {
      $('#treeDiv').jstree(true).set_icon(data.node, 'https://jstree.com/tree-icon.png');
    });

    $('#treeDiv').on('changed.jstree', (e, rpcdataChanged) => {
      /* tslint:disable:no-empty */
    }).jstree({
      plugins: ['changed'],
      checkbox: {
        three_state: false

      },
      core: {
        check_callback: true,
        data: rpcdata,
        themes: {
          icons: false
        }
      },
      types: {
        default: {
          icon: 'src/assets/images/tree.svg'
        }
      },
      icon: 'glyphicon glyphicon-file file-node',
      // tslint:disable-next-line: space-before-function-paren // tslint:disable-next-line: no-shadowed-variable
    }).bind('loaded.jstree', function (event, rpcdata123) {
      $(this).jstree('open_all');
    });
    $('#treeDiv').jstree(true).redraw(true);
  }
  /* istanbul ignore next */
  createRpcTreeUnilever(unileverRpcData) {
    unileverRpcData = this.applySelectiveRpcFilter(unileverRpcData);
    try {
      if ($.jstree.reference('#treeDivUni')) {
        $('#treeDivUni').jstree('destroy').empty();
      }
    } catch (e) {}
    $('#treeDivUni').off('changed.jstree');
    $('#treeDivUni').on('changed.jstree', (evt, data) => {
      $('#treeDivUni').jstree(true).set_icon(data.node, 'https://jstree.com/tree-icon.png');
    });

    $('#treeDivUni').on('changed.jstree', (e, unileverRpcDataChanged) => {
      /* tslint:disable:no-empty */
    }).jstree({
      plugins: ['changed'],
      checkbox: {
        three_state: false

      },
      core: {
        check_callback: true,
        data: unileverRpcData,
        themes: {
          icons: false
        }
      },
      types: {
        default: {
          icon: 'src/assets/images/tree.svg'
        }
      },
      icon: 'glyphicon glyphicon-file file-node',
      // tslint:disable-next-line: space-before-function-paren // tslint:disable-next-line: no-shadowed-variable
    }).bind('loaded.jstree', function (event, unileverRpcData123) {
      $(this).jstree('open_all');
    });
    $('#treeDivUni').jstree(true).redraw(true);
  }
  /* istanbul ignore next */
  getPrepareRuleTableData() {
    if (this.rulesLoadStarted) {
      return;
    }
    this.rulesLoadStarted = true;
    this.rulesLoading = true;
    this.execRulePageLoadingMessage = 'Fetching data from FAST Rule-Engine';
    this.sirIdList = [];
    if (recipeModel.formulationRequestDetails && Array.isArray(recipeModel.formulationRequestDetails)) {
      recipeModel.formulationRequestDetails.forEach(element => {
        this.sirIdList.push(element.substanceID);
      });
    }
    this.sirIDInvalidList = this.sirIdList.filter(x => x === 'SIR ID Not found');
    if (this.sirIDInvalidList.length > 0) {
      this.matSnackBar.open('Some pures in the recipe is not mapped with SIR ID', 'close', {
        duration: 5000,
        panelClass: ['success']
      });
    }
    this.sirIdList = this.sirIdList.filter(x => x !== 'SIR ID Not found' && x !== '');
    const apiurl = environment.APIFAsTRule + '/rules/rulesFilterActiveMrpc';
    const encodedTfcName = encodeURIComponent(encodeURIComponent(encodeURIComponent(recipeModel.tfc.tfcId)));
    const sirIds = _.uniq(this.sirIdList);
    // Keep each market's mapped RPCs isolated; never send a combined MarketList.
    // Sequential requests also avoid overlapping rule-engine work for fallback markets.
    const serviceCall = from(this.marketsToSelect).pipe(
      concatMap(market => {
        const rpcUrl = environment.APIFAsT + '/markets/' + market.marketId + '/tfcs/' + encodedTfcName + '/rpcs';
        return this.assessraService.getData(rpcUrl).pipe(
          concatMap(response => {
            const rpcs = (Array.isArray(response) ? response : []).map(value => ({
              rpcId: value.rpcId,
              rpcName: value.rpcDescription,
              rpcFullText: value.rpcSearchValue
            }));
            // An empty RPCList may broaden backend filtering, so skip unmapped markets.
            if (rpcs.length === 0) {
              return of({ rpcs, rules: [] });
            }
            return this.assessraService.postData(apiurl, {
              MarketList: [market],
              RPCList: rpcs,
              SIRIds: sirIds,
              TFCName: this.TFCName
            }).pipe(map(rules => ({ rpcs, rules: Array.isArray(rules) ? rules : [] })));
          })
        );
      }),
      toArray()
    );
    serviceCall.subscribe(results => {
      this.rpc = _.uniqBy([].concat(...results.map(result => result.rpcs)), value => String(value.rpcId));
      recipeModel.rpcList = this.rpc;
      const response = [].concat(...results.map(result => result.rules));
      if (response !== undefined && response.length !== 0) {
        this.prepareRuleBtnDissageFlag = false;
        this.prepareRuleTableData = response;
        // in case if request is of non plm type, then product rule and property rule should not be displayed
        if (!this.isPlm) {
          this.prepareRuleTableData = this.prepareRuleTableData.filter(f => (f.ruleClassification !== 'Product Based Rules' && f.ruleClassification !== 'Property Based Rules'));
        }
        this.prepareRuleTableData.forEach(data => {
          data.ruleVerionToDisplay = 'V' + data.ruleVersion;
          data.isAllergen = data.isAllergen === 'Y' ? 'Y' : '';
          data.allowedFuncFlag = data.ruleTypeID === 14 ? 'Y' : 'N';
          data.warningText = (data.warningStatement !== null && data.warningStatement !== '') ? data.warningStatement : ((data.warningText !== null) ? data.warningText : '');
          if (data.warningText !== '') {
            const warningLinkRuleData = this.assessraService.hyperLinksToSheet(data.warningText);
            data.warningText1 = warningLinkRuleData[0] !== undefined ? warningLinkRuleData[0] : '';
            data.warningText2 = warningLinkRuleData[1] !== undefined ? warningLinkRuleData[1] : '';
            data.warningText3 = warningLinkRuleData[2] !== undefined ? warningLinkRuleData[2] : '';
            data.warningText4 = warningLinkRuleData[3] !== undefined ? warningLinkRuleData[3] : '';
            data.warningText5 = warningLinkRuleData[4] !== undefined ? warningLinkRuleData[4] : '';
            data.warningText6 = warningLinkRuleData[5] !== undefined ? warningLinkRuleData[5] : '';
            data.warningText7 = warningLinkRuleData[6] !== undefined ? warningLinkRuleData[6] : '';
            data.originalWarningText = data.warningText;
            data.warningText = this.changeComment(data.warningText);
            data.warningTextStripped = this.handleSpecialCharacters(data.originalWarningText).substr(0, 14) + '...';
            data.warningTextStrippedExcel = this.handleSpecialCharacters(data.originalWarningText);
          }
          data.otherRestrictionsAndRequirements = (data.otherRestrictionsAndRequirements !== null) ? data.otherRestrictionsAndRequirements : '';
          if (data.otherRestrictionsAndRequirements !== '') {
            const orrLinkRuleData = this.assessraService.hyperLinksToSheet(data.otherRestrictionsAndRequirements);
            data.ORR1 = orrLinkRuleData[0] !== undefined ? orrLinkRuleData[0] : '';
            data.ORR2 = orrLinkRuleData[1] !== undefined ? orrLinkRuleData[1] : '';
            data.ORR3 = orrLinkRuleData[2] !== undefined ? orrLinkRuleData[2] : '';
            data.ORR4 = orrLinkRuleData[3] !== undefined ? orrLinkRuleData[3] : '';
            data.ORR5 = orrLinkRuleData[4] !== undefined ? orrLinkRuleData[4] : '';
            data.ORR6 = orrLinkRuleData[5] !== undefined ? orrLinkRuleData[5] : '';
            data.ORR7 = orrLinkRuleData[6] !== undefined ? orrLinkRuleData[6] : '';
            data.originalotherRestrictionsAndReq = data.otherRestrictionsAndRequirements;
            data.otherRestrictionsAndRequirements = this.changeComment(data.otherRestrictionsAndRequirements);
            data.otherRestrictionsAndRequirementsStripped =  this.handleSpecialCharacters(data.originalotherRestrictionsAndReq).substr(0, 14) + '...';
            data.otherRestrictionsAndRequirementsStrippedExcel = this.handleSpecialCharacters(data.originalotherRestrictionsAndReq);
          }
          // Bind Information and other MultiLimit columns using service
          this.columnBindingService.bindInformationAndRuleResultColumns([data]);

          if (data.cfDetails !== null) {
            data.cfSubstanceExpressedAs = data.cfDetails.component;
            data.cf = data.cfDetails.cf !== 0 ? data.cfDetails.cf : '';

          }
          if (data.ruleClassification === 'Substance Based Rules') {
            if (data.ruleTypeID === 30) {
              data.propertySource = data.propertyName;
              data.propertyName = '';
            }
          }
          if (data.ruleClassification === 'Property Based Rules') {
            if (PROPERTY_BASED_RULE_TYPE_IDS.includes(data.ruleTypeID)) {
              data.propertySource = 'CUC';
            }
          }
          if (data.ruleClassification === 'Substance Group Rules') {
            data.substanceGroup = data.groupName;
          }

        });
        if (this.dataService.getAssessmentClicked() === 'Self Assessment') {
          this.prepareRulePageTableView = false;
          this.prepareRuleTabView = true;
        }
      } else {
        this.prepareRuleTableData = [];
        this.prepareRuleBtnDissageFlag = true;
      }
      this.rulesLoading = false;
    }, (error) => {
      this.rulesLoading = false;
      this.rulesLoadStarted = false;
      this.prepareRuleBtnDissageFlag = true;
      this.matSnackBar.open('Unable to load rules for all markets. Please reload and try again.', 'close', {
        duration: 5000,
        panelClass: ['error']
      });
    });

  }
  handleSpecialCharacters(text) {
    return text.replace(/<.*?>/g, '').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&nbsp;.*?/gi, '').replace(/&amp;/g, '&');
  }

  prepareRulebtnclick() {
    this.prepareRulePageTableView = false;
    this.prepareRuleTabView = true;
  }
  goToWorklistBtnClick() {
    this.route.navigate(['/worklist/master-worklist']);
  }
  /*istanbul ignore next */
  getTFCbyID() {
    this.execRulePageLoadingMessage = 'Loading..';
    const apiurl = environment.APIFAsT + '/tfcid/' + recipeModel.tfc.tfcId;
    const serviceCall = this.assessraService.getData(apiurl);
    if (serviceCall !== undefined) {
      serviceCall.subscribe((response) => {
        if (response !== undefined && response.length !== 0) {
          this.tfcData = response;
          this.TFCName = this.tfcData[0].tfcFullText;
          this.initializeRulesView();
        } else {
          this.loading = false;
          this.matSnackBar.open('No TFC Found for TFC ID' + recipeModel.tfc.tfcId, 'close', {
            duration: 3000,
            panelClass: ['error']
          });
        }
      });
    }
  }
  /*istanbul ignore next */
  getRPCDataBasedOnMarket(marketSelected) {
    this.selectedRPC = '';
    this.rpcdataForTree = [];
    this.loading = true;
    this.rpcToSelect = [];
    this.execRulePageLoadingMessage = 'Loading..';
    const result = this.marketsToSelect.filter(x => x.marketName === marketSelected)[0];
    const apiurl = environment.APIFAsT + '/marketid/' + result.marketId + '/tfcid/' + recipeModel.tfc.tfcId + '/rpclist';
    const serviceCall = this.assessraService.getData(apiurl);
    if (serviceCall !== undefined) {
      serviceCall.subscribe((response) => {
        if (response !== undefined && response.length !== 0) {
          this.rpcToSelect = response;
          this.onRPCChangedLoad(response[0]);
        } else {
          this.loading = false;
          this.getTreeDataBasedOnMarket(response);
          this.matSnackBar.open('No RPCs are found for market ' + marketSelected, 'close', {
            duration: 3000,
            panelClass: ['error']
          });
        }
      });
    }
  }
  onRPCChanged(selectedRPC) {
    this.getTreeDataBasedOnMarket(selectedRPC.value);
  }
  onRPCChangedLoad(selectedRPCOnLoad) {
    this.getTreeDataBasedOnMarket(selectedRPCOnLoad);
  }

  /* istanbul ignore next */
  getTreeDataBasedOnMarket(rpcVal) {
    this.loading = true;
    $('#treeDiv').jstree('destroy').empty();
    $('#treeDivUni').jstree('destroy').empty();
    if (!this.TFCName && recipeModel.tfcFullText) {
      this.TFCName = recipeModel.tfcFullText;
    }
    const encodedTfcName = encodeURIComponent(encodeURIComponent(encodeURIComponent(this.TFCName)));
    const reqDisplayId = recipeModel.requestDisplayID;
    const queryParam = reqDisplayId ? '?requestdisplayid=' + encodeURIComponent(reqDisplayId) : '';
    let otherMarketRpcTreeApiurl;
    let unileverRpctreeApiurl;
    if (rpcVal.rpcId !== undefined) {
      otherMarketRpcTreeApiurl = environment.APIFAsT + '/markets/' + pureRulesDetailsModel.selectedMarketForRulesDisplay.marketName + '/tfcname/' + encodedTfcName + '/rpcs/fortree/rpc/' + rpcVal.rpcId + queryParam;
      unileverRpctreeApiurl = environment.APIFAsT + '/markets/Unilever/tfcname/' + encodedTfcName + '/rpcs/fortree/rpc/' + rpcVal.rpcId + queryParam;

    } else {
      unileverRpctreeApiurl = environment.APIFAsT + '/markets/Unilever/tfcname/' + encodedTfcName + '/rpcs/fortree/rpc/0' + queryParam;
      otherMarketRpcTreeApiurl = environment.APIFAsT + '/markets/' + pureRulesDetailsModel.selectedMarketForRulesDisplay.marketName + '/tfcname/' + encodedTfcName + '/rpcs/fortree/rpc/0' + queryParam;
    }
    const serviceCall = forkJoin([this.assessraService.getData(otherMarketRpcTreeApiurl), this.assessraService.getData(unileverRpctreeApiurl)]);
    if (serviceCall !== undefined) {
      serviceCall.subscribe((response) => {
        if (response[0] !== undefined && response[0].length > 0) {
          this.loading = false;
          this.rpcOtherMarket = response[0];
          this.createRpcTree(this.rpcOtherMarket);
        } else {
          this.rpcOtherMarket = [];
          this.createRpcTree(this.rpcOtherMarket);
        }
        if (response !== undefined && response[1].length > 0) {
          this.rpcUnileverMarket = response[1];
          this.createRpcTreeUnilever(this.rpcUnileverMarket);
        } else {
          this.rpcUnileverMarket = [];
          this.createRpcTreeUnilever(this.rpcUnileverMarket);
        }
        this.loading = false;
      }, (error) => {
        this.loading = false;
      });
    }
  }

    showOverlay(htmlContent) {
    this.overlayText = htmlContent;
    this.hideOverlay = false;
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }

  /* istanbul ignore next */
  hideOverlayPanel() {
    this.hideOverlay = true;
  }
  /* istanbul ignore next */
  openComment(data) {
    this.warningTextOpen = true;
    const mydata = data.originalWarningText;
    this.tablewarningComment = mydata.replace(new RegExp('<a', 'g'), '<a target="_blank"');
  }
  closePopup() {
    this.warningTextOpen = false;
  }
  /* istanbul ignore next */
  openCommentORR(data) {
    this.orrTextOpen = true;
    const mydata = data.originalotherRestrictionsAndReq;
    this.tableORRComment = mydata.replace(/<a/gi, '<a target="_blank"');
  }
  closePopupORR() {
    this.orrTextOpen = false;
  }
  /* istanbul ignore next */
  openCommentInformation(data) {
    this.informationTextOpen = true;
    const mydata = data.originalInformation;
    this.tableInformationComment = mydata.replace(new RegExp('<a', 'g'), '<a target="_blank"');
  }
  closePopupInformation() {
    this.informationTextOpen = false;
  }

  /* istanbul ignore next */
  changeComment(input) {
    const strValue = input;
    const ar = strValue.match(/<a.*?<\/a>/g);
    let commentwarning = '';
    if ((ar !== null) && (ar.length === 0 || ar.length > 0)) {
      commentwarning = 'Click Here';
    } else {
      commentwarning = input;
    }
    return commentwarning;
  }
  /* istanbul ignore next */
  handleSpecialCharactersForHyperlinks(text) {
    if (text !== null && text !== '') {
      return text.replace(/&nbsp;.*?/gi, ' ').replace(/&amp;/g, '&').replace(/<strong>/gi, '').replace(/<\/strong>/gi, '').replace(/<i>/gi, '').replace(/<\/i>/gi, '');
    } else {
      return '';
    }
  }
  /* istanbul ignore next */
  hyperLinksToSheet(comment) {
    const regex = /<a[^>]*href=["']([^"']*)["']/gm;
    const aregText = /<a(.*?)<\/a>/gm;
    const hyperLinksData = [];
    let m;
    let getraAncharText;
    const totalAnchor = [1, 2, 3, 4, 5, 6, 7];
    const textbetweenTags = [];
    if (comment !== null || comment !== '') {
      for (const val of totalAnchor) {
        getraAncharText = aregText.exec(comment);
        if (getraAncharText == null) {
          break;
        }
        if (getraAncharText.index === aregText.lastIndex) {
          aregText.lastIndex++;
        }
        getraAncharText.forEach((amatch, agroupIndex) => {
          if (agroupIndex === 1) {
            const aindex = amatch.indexOf('>');
            const matchLength = amatch.length;
            textbetweenTags.push(amatch.substring(aindex + 1, matchLength));
          }
        });
      }
      let index = 0;
      for (const val of totalAnchor) {
        m = regex.exec(comment);
        if (m == null) {
          break;
        }
        if (m.index === regex.lastIndex) {
          regex.lastIndex++;
        }
        m.forEach((match, groupIndex) => {
          if (groupIndex === 1) {
            hyperLinksData.push(
              {
                text: this.handleSpecialCharactersForHyperlinks(textbetweenTags[index]),
                hyperlink: match,
                tooltip: match,
                color: 'red'
              });
            index = index + 1;
          }
        });
      }
    }
    return hyperLinksData;
  }
}
